import {ControllerBase} from "../../../controllerBase";

declare var window:any
declare var PedidoFornecedorView: any
declare var PedidosFornecedores: any

const PedidoFornecedorController = ControllerBase.extend({
    name: "PedidoFornecedorController",

    //dataBreadcrumb: new DataBreadcrumb({
    //    columns: [
    //        { title: 'Produto', prop: 'Codigo' },
    //        { title: 'Descrição', prop: 'Descricao' }
    //    ],
    //    getData: function () {
 
    //        return this.itemOrcamento.toJSON(); 
    //    },
    //}),

    ajax: function () {

        var numeroPedido = 0; 
        if (this.parent && this.parent.parent && this.parent.parent.model)
            numeroPedido = this.parent.parent.model.get("Numero"); // FNX-5487

        var pesquisa = {
            CodigoProduto: this.itemOrcamento.get("Codigo"),
            CodigoFilial: this.itemOrcamento.get("Filial"),
            NumeroPedido: numeroPedido,
            TamanhoPagina: this.pesquisa ? this.pesquisa.PageSize : 0,
            NumeroPagina: this.pesquisa ? this.pesquisa.ActualPage : 0
        };

        return {
            url: "/Produto/_PedidoFornecedor",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                pesquisa: pesquisa
            })
        };
    },

    totalQuantidadeNaoEntregue: function(model) {
        return model.reduce(function(memo, value) { return memo + value.QuantidadeNaoEntregue }, 0);
    },

    atualizarTotal: function() {
        $("#td-pedido-fornecedor-total-nao-entregue").html(global
            .formatNumber(this.totalQuantidadeNaoEntregue(this.model), 3));
    },

    renderizado: function() {

        this.PedidoFornecedorView = this.showView({
            region: {
                name: "pedidoFornecedorViewRegion",
                selector: "#pedido-fornecedor-region"
            },
            view: {
                type: PedidoFornecedorView,
                args: {
                    collection: new PedidosFornecedores(this.model)
                }
            }
        });

        $("#descricao-produto-pedido-fornecedor").html("<h3>" + this.produto + "</h3>");

        this.atualizarTotal();
    }

})

window.PedidoFornecedorController = PedidoFornecedorController

export {
    PedidoFornecedorController
}